import React from 'react';

import StockTabsPanel from '@/components/StockTabsPanel';
import Filters from '@/modules/CarsStock/components/Desktop/components/Filters';
import { useStockCarsTabs } from '@/modules/CarsStock/components/common.hooks';

import { TabsProps } from './types';

function Tabs({ carsType }: TabsProps) {
  const { activeTab, tabs, die } = useStockCarsTabs(carsType);

  if (!tabs || tabs.length === 0) {
    return null;
  }

  return (
    <StockTabsPanel activeTab={activeTab} tabs={tabs} die={die}>
      <Filters carsType={carsType} />
    </StockTabsPanel>
  );
}

export default Tabs;
